module.exports = __webpack_public_path__ + "static/media/zulfiqar.96bc59b5.PNG";